import { render, staticRenderFns } from "./AddRelevancyRule.vue?vue&type=template&id=3ac205a2&scoped=true"
import script from "./AddRelevancyRule.vue?vue&type=script&lang=js"
export * from "./AddRelevancyRule.vue?vue&type=script&lang=js"
import style0 from "./AddRelevancyRule.vue?vue&type=style&index=0&id=3ac205a2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac205a2",
  null
  
)

export default component.exports